import { AfterViewInit, Component, NgZone } from '@angular/core'
import { StyleThemeService } from './services/style-theme.service'
import { ChangeDetectionService } from './services/change-detection.service' // path to the service you created

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements AfterViewInit {
  title = 'otimus20-ng'

  constructor(
    private styleThemeService: StyleThemeService,
    private zone: NgZone,
    private changeDetectionService: ChangeDetectionService
  ) {
    this.zone.runOutsideAngular(() => {
      document.addEventListener('input', (event: Event) => {
        const target = event.target as HTMLElement

        if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA') {
          this.changeDetectionService.handleGlobalInput(target) // pass element for adaptive debouncing
          this.changeDetectionService.debounceReattach() // reattach after typing stops
        }
      })
    })
  }

  ngAfterViewInit(): void {
    this.styleThemeService.checkAndSetStyleTheme()
  }
}
